// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__J1pRK","chevron":"IconPlus_chevron__q0eW6","chevronOpen":"IconPlus_chevronOpen__Jie9j"};